import * as React from 'react';

export const CHAT_PANE_TRANSITION_MS = 250;

interface IProps {
  chatId:number|undefined;
  className:string;
  children:(isOpening:boolean, pane:React.RefObject<HTMLDivElement>) => React.ReactNode;
}

interface IState {
  chatId:number|undefined;
  isOpening:boolean;
}

// Keep the slide independent of keyboard/visual-viewport compensation on the
// outer pane. Refreshes can resume once this layer has finished moving.
export default class ChatPane extends React.Component<IProps, IState> {
  public static getDerivedStateFromProps(props:IProps, state:IState) {
    return props.chatId !== state.chatId
      ? {chatId:props.chatId, isOpening:props.chatId !== undefined}
      : null;
  }

  private pane = React.createRef<HTMLDivElement>();
  private openingTimeout:number|undefined;

  constructor(props:IProps) {
    super(props);
    this.state = {chatId:props.chatId, isOpening:props.chatId !== undefined};
  }

  public componentDidMount() {
    this.scheduleOpeningComplete();
  }

  public componentDidUpdate(previous:IProps) {
    if (previous.chatId !== this.props.chatId) {
      this.scheduleOpeningComplete();
    }
  }

  public componentWillUnmount() {
    window.clearTimeout(this.openingTimeout);
  }

  public render() {
    return <div ref={this.pane} className={this.props.className}
      style={{transform:`translate3d(${this.props.chatId !== undefined ? '0' : '100%'}, 0, 0)`}}
      onTransitionEnd={(event) => {
        if (event.target === event.currentTarget && event.propertyName === 'transform') {
          this.finishOpening();
        }
      }}>
      {this.props.children(this.state.isOpening, this.pane)}
    </div>;
  }

  private scheduleOpeningComplete() {
    window.clearTimeout(this.openingTimeout);
    if (this.state.isOpening) {
      const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // A direct link, interrupted transition, or reduced motion may not emit
      // transitionend. Never leave the room waiting for an event that won't fire.
      this.openingTimeout = window.setTimeout(this.finishOpening,
        reducedMotion ? 0 : CHAT_PANE_TRANSITION_MS + 100);
    }
  }

  private finishOpening = () => {
    window.clearTimeout(this.openingTimeout);
    if (this.state.isOpening) {
      this.setState({isOpening:false});
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/chat/ChatPane.tsx